module.exports = __webpack_public_path__ + "static/media/promotionResumptionPackageUnder35.5c009b7f.webp";